import { FlowStepData } from "../FlowStepData";
import { ExpressionConfiguration } from "../../../Expressions/ExpressionConfiguration";
import { BooleanDataDefinition } from "../../../Common/Data/Definitions/BooleanDataDefinition";
import { DataDefinition } from "../../../Common/Data/DataDefinition";

export class RunExpression extends FlowStepData {
    readonly __type: string = "run_expression";

    expression: ExpressionConfiguration = new ExpressionConfiguration();
    outputVariableName?: string;

    constructor() {
        super();

        this.expression.executionResult = new BooleanDataDefinition();

        this.expression.inputData = () => {
            return this.sequence?.flow?.getInputDefinition() || new DataDefinition();
        };

        this.name = "Run Expression";
    }

    getStorageData(): object {
        let data = super.getStorageData();

        Reflect.set(data, "expression", this.expression.getStorageData());
        return data;
    }

    setStorageData(data: object) {
        super.setStorageData(data);

        this.expression.setStorageData(Reflect.get(data, "expression"));
    }
}
